$(".hamburger").click(function() {
    $(this).toggleClass('is-active');
    $('.trigger-nav-wrap').toggleClass('toggle');
    if ($(this).hasClass('is-active')) {
        $('html, body').animate({ scrollTop: 0 }, 0);
    }
});
$(".search-trigger").click(function() {
    $(this).parent().toggleClass('toggle');
});



var productsFilter = {
    init: false,
    timer: null,
    initFilterSliders: function(){},
    initMasonry: function(){},
    jq: function(jQuery) {
        return $ || jQuery;
    },
    filterRequestTimer: function() {
        clearTimeout(productsFilter.timer);
        productsFilter.timer = setTimeout(productsFilter.filterUriParams, 500);
    },
    filterUriParams: function() {
        $ = productsFilter.jq();
        var $container = $('.author-single-right').length ? $('.grid:first') : $('.page:first');
        $('html, body').animate({ scrollTop: $container.offset().top - 60 }, 300);

        var loc = top.location.origin + top.location.pathname.replace(/page\/\d+\/?/, '') + '?',
            path = [],
            params = {};

        $('.last-sm.content-right :input').each(function(i, el) {
            var key = $(el).attr('class'),
                val = $(el).val() === 'on' ? 1 : $(el).val();

            if (($(el).attr('type') === 'checkbox' && !$(el).is(':checked')) || !val || val == 0)
                return;

            if (!$.isArray(params[key]))
                params[key] = [];

            params[key].push(val);
        });

        $.each(params, function(k, v) {
            if ($.isArray(v))
                v = v.join(',');

            path.push(k +'='+ v);
        });

        if ($('.authors-filter-hold form').hasClass('author')) {
            path.push('where=1');
            path.push('authors='+ $('.authors-box input').val());
        }

        if ($('.letters-list:visible .active').length)
            path.push('sort_letter='+ $('.letters-list:visible .active').text());

        //top.location = loc + path.join('&');
        window.history.pushState('', '', loc + path.join('&'));
        productsFilter.get(loc + path.join('&'));
    },
    get: function(url) {
        $ = productsFilter.jq();
        $.ajaxSetup({ cache: false });
        $.get(url, function (response) {
            var loadingMessage;
            var responseContent = $(response).filter('.page');

            if (responseContent.find('.grid > .grid-item').length) {
                $('.page').replaceWith(responseContent);
                loadingMessage = 'Kraunasi...';
            } else {
                loadingMessage = 'Nieko nerasta. Pasirinkite kitus filtrus šoninėje naršymo srityje.';
            }

            // todo
            if ($('body').hasClass('post-type-archive-author')) {
                if (responseContent.find('.block-author').length) {
                    $('.page').replaceWith(responseContent);
                } else {
                    $('.authors-list-images').text('Autorių nerasta.');
                }
            }

            $('.page .grid').before('<div class="filterLoading">'+ loadingMessage +'</div>');
            $('.page .block').css('visibility', 'hidden');

            productsFilter.init = false;
            productsFilter.initFilterSliders();
            productsFilter.initMasonry();

            if ($('.authors-box').length)
                $('.authors-box').mCustomScrollbar();

            setTimeout(function() {
                $('.filterLoading').remove();
                $('.page .block').css('visibility', 'visible');
            }, 500);
        });
    },
    clearSliders: function() {
        $ = productsFilter.jq();

        if ($('#price-slider').length) {
            $('#price-slider')[0].noUiSlider.updateOptions({ range: { 'min': 0, 'max': 10000 } });
            $('#price-slider')[0].noUiSlider.set([0, 10000]);

            $('#years-slider')[0].noUiSlider.updateOptions({ range: { 'min': 1900, 'max': 2018 } });
            $('#years-slider')[0].noUiSlider.set([1900, 2018]);

            $('#height-slider')[0].noUiSlider.updateOptions({ range: { 'min': 0, 'max': 1000 } });
            $('#height-slider')[0].noUiSlider.set([0, 1000]);

            $('#width-slider')[0].noUiSlider.updateOptions({ range: { 'min': 0, 'max': 1000 } });
            $('#width-slider')[0].noUiSlider.set([0, 1000]);
        }
    }
};

jQuery(document).ready(function($) {

    // Navigation
    // $('header .navicon').click(function() {
    //     $(this).toggleClass('close');
    //     $('.header-content').toggleClass('visible-md');
    // });
    $('header .navicon').click(function() {
        $(this).toggleClass('close');
        $('.trigger-nav-hold').toggleClass('close');
    });

    $('a.search').click(function() {
        $('header').toggleClass('toggle');
        $('.header-search-input input').focus();
    });


    $(document).on('click', '.js-list-names', function() {
        $(this).hide();
        $('.authors-list-images').hide()
        $('.js-list-images').show()
        $('.authors-list-names').show()
    });

    $(document).on('click', '.js-list-images', function() {
        $(this).hide();
        $('.authors-list-names').hide()
        $('.js-list-names').show()
        $('.authors-list-images').show()
    });

    $(document).on('click', '.filter-visiblity', function() {
        $(this).toggleClass('toggle');
        $('.authors-sort').toggleClass('visible-md visible-sm');
        $('.authors-filter-hold').toggleClass('visible-md visible-sm');
    });

    //work gallery
    if ($("#carousel").length > 0){

        $('#carousel').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            itemWidth: 160,
            itemMargin: 10,
            asNavFor: '#slider'
        });

        $('#slider').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            smoothHeight: true,
            sync: "#carousel"
        });
    }

    //custom scroll bar
    if( $(".authors-box").length ) {
        $(".authors-box").mCustomScrollbar();
    }

    //tabs
    $('#infoTabs a').on('click', function (e) {
        currentTab = $(this).attr('href');
        if (currentTab.indexOf('#') > -1) {
            e.preventDefault();
        } else {
            currentTab = '#reserve';
        }
        $('.nav-link').removeClass('active');
        $(this).addClass('active');
        $('.tab-pane').removeClass('active');
        $('.tab-content').find(currentTab).addClass('active');
    })

    //tabs authors
    $('.author-single-nav a').on('click', function (e) {
        e.preventDefault();
        $('.author-single-nav ul li').removeClass('current');
        $(this).parent().addClass('current');
        currentAuthorTab = $(this).attr('href');
        // console.log(currentAuthorTab);
        $('.author-tab-content').removeClass('current');
        $('.author-tabs').find(currentAuthorTab).addClass('current');
    })

    //tabs carousel
    $('.gallery-tabs a').on('click', function (e) {
        e.preventDefault();
        var cBlock = $(this).closest('.block-carousel-tabs');
        cBlock.find('.gallery-tabs ul li').removeClass('current');
        $(this).parent().addClass('current');
        currentTab = $(this).attr('href');
        tabText = $(this).text();
        tabUrl = $(this).data('url');
        cBlock.find('.gallery-tabs-content').removeClass('current');
        cBlock.find('.gallery-tabs-content-hold').find(currentTab).addClass('current');
        cBlock.find('.section-title a').text(tabText).attr('href', tabUrl);
    })

    //accordion
    $(".accordion-item:first-child").addClass('active');
    $(".accordion-title").click(function(e) {
        var href = $(this).attr('href');
        if (href && href.indexOf('#') > -1) {
            e.preventDefault();
        } else {
            // window.open(href);
        }
        if ($(this).parent().hasClass("active")) {
            $(this).parent().find('.accordion-text').slideUp();
            $(".accordion-title").removeClass('active');
            $(this).parent().removeClass('active');
        }
        else {
            $('.accordion-text').slideUp();
            $(".accordion-item").removeClass('active');
            $(this).parent().find('.accordion-text').slideDown();
            $(this).parent().addClass('active');
        }
        return false;
    });

    productsFilter.initMasonry = function() {
        // masonry
        $('.grid').imagesLoaded(function() {
            $('.grid').masonry({
                // options
                columnWidth: '.grid-item',
                gutter: '.gutter-sizer',
                itemSelector: '.grid-item',
                percentPosition: true
            });
        });

        $('.grid2').imagesLoaded(function() {
            $('.grid2').masonry({
                // options
                columnWidth: '.grid-item2',
                gutter: '.gutter-sizer2',
                itemSelector: '.grid-item2',
                percentPosition: true
            });
        });
    };

    productsFilter.initMasonry();

    function appendHiddenInputs(min, minVal, max, maxVal, to) {
        productsFilter.init = true;

        $('<input>').attr({ 'class': min, id: min, name: min, type: 'hidden', value: minVal }).appendTo(to);
        $('<input>').attr({ 'class': max, id: max, name: max, type: 'hidden', value: maxVal }).appendTo(to);

        document.getElementById(to.slice(1)).noUiSlider.on('update', function(values, handle) {
            var value = Math.round(values[handle]);

            if (handle) {
                $('#'+max).val(value).trigger('change');
            } else {
                $('#'+min).val(value).trigger('change');
            }
        });

        productsFilter.init = false;
    }

    productsFilter.initFilterSliders = function() {

        var filterConf = window.filterConf || {};

        // price range
        if ($('#price-slider').length > 0) {
            var sliderPrice = document.getElementById('price-slider');
            var minPrice = parseInt(filterConf.minPrice) || 0,
                maxPrice = parseInt(filterConf.maxPrice) || 10000;

            maxPrice = minPrice == maxPrice ? maxPrice + 1 : maxPrice;

            noUiSlider.create(sliderPrice, {
                start: [minPrice, maxPrice],
                connect: true,
                tooltips: [ wNumb({ decimals: 0}), wNumb({ decimals: 0}) ],
                range: {
                    'min': minPrice,
                    'max': maxPrice
                }
            });

            appendHiddenInputs('minPrice', minPrice, 'maxPrice', maxPrice, '#price-slider');
        }

        // years range
        if ($('#years-slider').length > 0) {
            var sliderYear = document.getElementById('years-slider');
            var minYear = parseInt(filterConf.minYear) || 1900,
                maxYear = parseInt(filterConf.maxYear) || 2018;

            maxYear = minYear == maxYear ? maxYear + 1 : maxYear;

            noUiSlider.create(sliderYear, {
                start: [minYear, maxYear],
                connect: true,
                tooltips: [ wNumb({ decimals: 0}), wNumb({ decimals: 0}) ],
                range: {
                    'min': minYear,
                    'max': maxYear
                }
            });

            appendHiddenInputs('minYear', minYear, 'maxYear', maxYear, '#years-slider');
        }


        // height range
        if ($('#height-slider').length > 0) {
            var sliderHeight = document.getElementById('height-slider');
            var minHeight = parseInt(filterConf.minHeight) || 0,
                maxHeight = parseInt(filterConf.maxHeight) || 1000;

            maxHeight = minHeight == maxHeight ? maxHeight + 1 : maxHeight;

            noUiSlider.create(sliderHeight, {
                start: [minHeight, maxHeight],
                connect: true,
                tooltips: [ wNumb({ decimals: 0}), wNumb({ decimals: 0}) ],
                range: {
                    'min': minHeight,
                    'max': maxHeight
                }
            });

            appendHiddenInputs('minHeight', minHeight, 'maxHeight', maxHeight, '#height-slider');
        }

        // width range
        if ($('#width-slider').length > 0) {
            var sliderWidth = document.getElementById('width-slider');
            var minWidth = parseInt(filterConf.minWidth) || 0,
                maxWidth = parseInt(filterConf.maxWidth) || 1000;

            maxWidth = minWidth == maxWidth ? maxWidth + 1 : maxWidth;

            noUiSlider.create(sliderWidth, {
                start: [minWidth, maxWidth],
                connect: true,
                tooltips: [ wNumb({ decimals: 0}), wNumb({ decimals: 0}) ],
                range: {
                    'min': minWidth,
                    'max': maxWidth
                }
            });

            appendHiddenInputs('minWidth', minWidth, 'maxWidth', maxWidth, '#width-slider');
        }

    };

    productsFilter.initFilterSliders();

    // filter and ranges reset
 /*   $('.filter-clear a').click(function(){
        $('.authors-filter-hold form')[0].reset();
        sliderPrice.noUiSlider.set([0, 10000]);
        sliderYear.noUiSlider.set([1900, 2018]);
        sliderHeight.noUiSlider.set([0, 1000]);
        sliderWidth.noUiSlider.set([0, 1000]);
    });*/

    // filter reset
    $(document).on('click', '.filter-clear a',function() {
        window.history.pushState('', '', top.location.origin + top.location.pathname.replace(/page\/\d+\/?/, ''));

        $('.authors-filter-hold form')[0].reset();
        $('.authors-filter-hold :input').prop('checked', false);

        productsFilter.clearSliders();

        if ($('.letters-list').length) {
            $('.letters-list a').removeClass('active');
            productsFilter.filterRequestTimer();
        }
    });

    // $('header .menu a').click(function() {
    //     $('.navicon').removeClass('close');
    //     $('.header-content').addClass('visible-md');
    // });

    // Click outside functions
    $(document).on('click', function (event) {
        // Close side navigation
        if (! $(event.target).closest('.header-trigger').length) {
            $('.trigger-nav-hold').removeClass("close");
            $('.header-trigger button').removeClass("close");
            $('.header-trigger-main-nav ul li ul').slideUp();
            $('.header-trigger-main-nav ul li span').removeClass('toggle')
        }

        // Close group links
        if (! $(event.target).parent().hasClass('group-title')) {
            $('.group-links').addClass('hidden');
        }
    });

    // fancybox thumbnails
    $('[data-fancybox]').fancybox({
        loop: false,
        thumbs: {
            autoStart: true,
            axis: 'y'
        },
        mobile : {
            thumbs : {
                autoStart: false
            }
        }
    });

    $('[data-fancybox="images"]').fancybox({
        mobile : {
            fullScreen : {
                requestOnStart : true
            }
        }
    });

    function mosaicGallery() {
        if (!$('.block-gallery img').length) return;

        var window_width = Math.ceil($(window).width());

        $(document).on('jMosaic', function(e, galleryObj) {
            var $gallery = galleryObj.gallery;
            if ($gallery.find('.lastGalleryItem').length) return;

            var $lastItem = $gallery.find('img:visible:last');
            if (window_width > 500 && $lastItem.width() > (Math.floor($('.block-gallery').width() / 100) * 100)) {
                $lastItem.hide();
            }

            var moreItems = postGalleries[$gallery.data('id')];
            if (!moreItems || moreItems < 1) return;

            $lastItem = $gallery.find('img:visible:last');
            $lastItem
                .wrap('<div class="lastGalleryItem" style="width: '+ $lastItem.width() +'px" />')
                .after('<div class="lastGalleryItemCount" style="height: '+ $lastItem.height() +'px"><span>+'+ moreItems +'</span></div>');
        });

        setTimeout(function() {
            $('.lastGalleryItem > img').unwrap();
            $('.lastGalleryItemCount').remove();
            $('.block-gallery > img').removeAttr('style');

            $('.block-gallery').jMosaic('clear').jMosaic({
                items_type: 'img',
                min_row_height: window_width > 500 ? 150 : 60,
                margin: 3,
                //is_first_big: true
            });

        }, 1000);
    }

    mosaicGallery();

    // newsletter close
    $('.news-letter-close').click(function() {
        $('.block-newsletter').fadeOut();
    });

    // append arrow in nav
    $('.header-main-nav ul li ul li.menu-item-has-children').append('<span></span>');
    $('.header-sec-nav ul li ul li.menu-item-has-children').append('<span></span>');
    $('.header-trigger-main-nav ul  li.menu-item-has-children').append('<span></span>');
    $('.header-trigger-sec-nav ul li.menu-item-has-children').append('<span></span>');
    $('.projects-nav ul li.menu-item-has-children').append('<span></span>');
    $('.trigger-nav ul li.menu-item-has-children > a').append('<span></span>');

    // 
    $('.trigger-nav ul li.menu-item-has-children a span').on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('toggle')
        $(this).parent().parent().children('ul').slideToggle()
    });
    // main nav ul ul ul
    $('.header-main-nav > ul > li > ul > li > span').click(function() {
        $(this).toggleClass('toggle')
        $(this).parent().children('ul').slideToggle()
    });
    $('.projects-nav > ul > li > span').click(function() {
        $(this).parent().children('ul').slideToggle()
        $(this).parent().toggleClass('toggle')
    });

    // main nav ul ul ul ul
    $('.header-main-nav > ul > li > ul > li > ul li span').click(function() {
        $(this).toggleClass('toggle')
        $(this).parent().children('ul').slideToggle()
    });

    // sec nav ul ul ul
    $('.header-sec-nav > ul > li > ul > li > span').click(function() {
        $(this).toggleClass('toggle')
        $(this).parent().find('ul').slideToggle()
    });

    // side main nav ul ul
    $('.header-trigger-main-nav > ul > li > span').click(function() {
        $(this).toggleClass('toggle')
        $(this).parent().children('ul').slideToggle()
    });
    // side main nav ul ul ul
    $('.header-trigger-main-nav > ul > li > ul > li > span').click(function() {
        $(this).toggleClass('toggle')
        $(this).parent().children('ul').slideToggle()
    });

    // side main nav ul ul ul ul
    $('.header-trigger-main-nav > ul > li > ul > li > ul li span').click(function() {
        $(this).toggleClass('toggle')
        $(this).parent().children('ul').slideToggle()
    });

    // side sec nav ul ul
    $('.header-trigger-sec-nav ul li span').click(function() {
        $(this).toggleClass('toggle')
        $(this).parent().find('ul').toggleClass('close')
    });
    // side sec nav ul ul ul
    $('.header-trigger-sec-nav ul li ul li span').click(function() {
        // $(this).toggleClass('toggle')
        $(this).parent().find('ul').toggleClass('toggle')
    });



    // sticky nav
    var $window = $(window);
    $window.scroll(function () {
        $scroll = window.scrollY;
        if ($scroll > 130) {
            $('.header').stop().addClass('sticky');
        }
        if ($scroll < 130) {
            $('.header').stop().removeClass('sticky');
        }
    });


    // Carousel item equal height
    var updateTabsCarousels = function() {
        setTimeout(function() {
            $(".gallery-tabs-content.current").each(function() {
                var maxH = 0;
                var firstRowActiveItems = $(this).find(".owl-item.active .block-item:first-child .content");
                firstRowActiveItems.each(function() {
                    firstRowActiveItems.css('min-height', '');
                    itemH = parseInt($(this).outerHeight());
                    maxH = (itemH > maxH) ? itemH : maxH;
                });
                firstRowActiveItems.css('min-height', maxH);
            });
        }, 500);
    };

    // owl carousel
    $('.owl-carousel.carousel-gallery').owlCarousel({
        loop:true,
        margin:40,
        responsiveClass:true,
        autoHeight:true,
        dots: false,
        nav:true,
        //loop:false,
        responsive:{
            0:{
                items:1,
                margin:10,
                slideBy:2,
                stagePadding: 60,
                nav: false
            },
            // 600:{
            //     items:2,
            //     margin:10,
            //     slideBy:3
            // },
            800:{
                items:3,
                margin:30,
                slideBy:3
            },
            1244:{
                items:4,
                slideBy:4
            }
        }
    });

    $('.owl-carousel.tabs-carousel').owlCarousel({
        loop:true,
        responsiveClass:true,
        autoHeight:true,
        dots: true,
        nav:false,
        //loop:false,
        responsive:{
            0:{
                items:2,
                margin:20,
                slideBy:2,
                stagePadding: 25,
                nav: false
            },
            800:{
                items:3,
                margin:20,
                slideBy:3
            },
            1244:{
                margin:20,
                items:4,
                slideBy:4
            }
        },
        onInitialized: updateTabsCarousels,
        onChanged: updateTabsCarousels
    });

    // side nav height
    $window = $(window).outerHeight();
    $header = $('header').outerHeight();
    $sideNavH = $window - $header;
    $sideNavH2 = $window - $header - 10;
    $('.trigger-nav-hold').css('max-height', $sideNavH+'px')
    $('.header-sec-nav>ul>li>ul').css('max-height', $sideNavH2+'px')
    $(window).on('resize', function(){
        $window = $(window).outerHeight();
        $header = $('header').outerHeight();
        $sideNavH = $window - $header;
        $('.header-sec-nav>ul>li>ul').css('max-height', $sideNavH+'px')
        $('.trigger-nav-hold').css('max-height', $sideNavH2+'px');

        if(!(/Android|iPhone|iPod|iPad|Opera Mini|IEMobile|BlackBerry/).test(navigator.userAgent)) {
            mosaicGallery();
        }
    });

    $(window).on('orientationchange', function() {
        setTimeout(function() {
            mosaicGallery();
        }, 300);
    });

    //owl carousel arrow bg height
    picH = $('.owl-carousel-block .image').outerHeight();
    $('.owl-nav').css('height', picH+'px')

    $(window).on('resize', function(){
        picH = $('.owl-carousel-block .article-img a').outerHeight();
        $('.owl-nav').css('height', picH+'px')
    });

    var $resizeImages = $('.entry p>img.size-full.aligncenter');
    if ($resizeImages.length) {
        $resizeImages.parent().css('padding-left', 0);
    }

    var $resizeImages = $('.entry p>img.aligncenter');
    if ($resizeImages.length) {
        $resizeImages.parent().css('padding-left', 0);
        $resizeImages.parent().css('margin-bottom', 0);
    }

    var $resizeImages = $('.entry p>img.alignleft');
    if ($resizeImages.length) {
        $resizeImages.parent().css('padding-left', 0);
        $resizeImages.parent().css('margin-bottom', 0);
    }

    var $resizeImages = $('.entry p>em>a>img.size-full.alignleft');
    if ($resizeImages.length) {
        $resizeImages.parents('p').css('padding-left', 0);
    }

    var $resizeCaptionImages = $('.wp-caption>img.size-full');
    if ($resizeCaptionImages.length) {
        $resizeCaptionImages.css('max-width', '100%').parent().css('max-width', '100%');
    }

    var $resizeCaptionImages = $('.entry p>a>img.size-full.alignleft, .entry p>a>img.size-full.aligncenter, .entry p>a>img.size-medium.alignleft');
    if ($resizeCaptionImages.length) {
        $resizeCaptionImages.parents('p').css('padding-left', 0);
    }

    var $resizeCaptionImages = $('.entry p>strong>a>img.size-full.alignleft');
    if ($resizeCaptionImages.length) {
        $resizeCaptionImages.parents('p').css('padding-left', 0);
    }

    var $resizeCaptionImages = $('.entry p>iframe');
    if ($resizeCaptionImages.length) {
        $resizeCaptionImages.parents('p').css('padding-top', 76+'%');
        $resizeCaptionImages.parents('p').css('position', 'relative');
        $resizeCaptionImages.parents('p').css('overflow', 'hidden');
        if (window.matchMedia("(max-width: 760px)").matches) {
            $resizeCaptionImages.parents('p').css('padding-top', 185+'%');
        }
    }
    var $resizeCaptionImages = $('.entry p>iframe');
    if ($resizeCaptionImages.length) {
        $resizeCaptionImages.css('width', 100+'%');
        $resizeCaptionImages.css('height', 100+'%');
        $resizeCaptionImages.css('position', 'absolute');
        $resizeCaptionImages.css('top', 0);
        $resizeCaptionImages.css('left', 0);
        $resizeCaptionImages.css('border', 0);
    }

    $(document).on('change', '.last-sm.content-right :input', function() {
        if (productsFilter.init) return;

        if ($(this).hasClass('category') || $(this).hasClass('warehouses') || $(this).hasClass('format'))
            productsFilter.clearSliders();

        productsFilter.filterRequestTimer();
    });

    $(document).on('click', '.letters-list li a', function(e) {
        e.preventDefault();
        $('.letters-list a').removeClass('active');
        $(this).addClass('active');
        productsFilter.filterRequestTimer();
    });


    // Event calendar filters
    $('.cities-list li a').click(function(e) {
        e.preventDefault();
        var city = $(this).data('city');
        var reset = $(this).parent().hasClass('current');
        if (reset) {
            $(this).parent().removeClass('current');
            $('.events-list .block-item-event').removeClass('hidden');
            return;
        }
        $(this).parent().siblings().removeClass('current');
        $(this).parent().addClass('current');
        $('.events-list .block-item-event').addClass('hidden');
        $('.tag-' + city).removeClass('hidden');
        // $('.events-list .block-item-event').each(function() {
        //     var item = this;
        //     var tags = $(this).data('tags');
        //     if (tags) {
        //         tags.split(',').forEach(function(tagName) {
        //             $('.tag' + tagName).removeClass('hidden');
        //         });
        //     }
        // });
    });
    $('#event-calendar-tag-filter').change(function() {
        var tag = $(this).val();
        if (tag == 'all') {
            $('.events-list .block-item-event').removeClass('hidden2');
            return;
        }
        $('.events-list .block-item-event').addClass('hidden2');
        $('.tag-' + tag).removeClass('hidden2');
    });


    // Form messages
    var err_msg = 'Klaida!';
    function formSubmited(form, data, type) {
        $('#' + form + ' .error').removeClass('error');
        if (data.status == 'ok') {
            $('#' + form)[0].reset();
            alert('Jūsų registracija išsiųsta.');
        } else if (typeof data.errors === 'object') {
            $.each( data.errors, function( field_name, value ) {
                $('#' + form + ' [name="' + field_name + '"]').addClass('error');
            });
        }
    }

    // MI Registracija
    var miRegisterForm = $('#mi_register');
    miRegisterForm.submit(function( event ) {
        event.preventDefault();
        var form = $(this).attr('id');
        $.ajax({
            type: "POST",
            url: '/',
            data: {
                mi_register:1,
                company:this.company.value,
                company_code:this.company_code.value,
                address:this.address.value,
                phone:this.phone.value,
                email:this.email.value,
                website:this.website.value,
                person:this.person.value,
                message:this.message.value
            },
            success: function(data) {
                formSubmited(form, data, 'mi_register');
            },
            error: function(data) {
                alert(err_msg);
            }
        });
    });

    // ScrollMagic
    var scrollLoad = $('.scroll-load');
    setTimeout(function(){
        scrollLoad.masonry('destroy');
        scrollLoad = scrollLoad.masonry({
            // options
            columnWidth: '.grid-item',
            gutter: '.gutter-sizer',
            itemSelector: '.grid-item',
            percentPosition: true
        });
    }, 800);
    var controller = new ScrollMagic.Controller();
    var scene = new ScrollMagic.Scene({triggerElement: "#loader", triggerHook: "onEnter"})
        .addTo(controller)
        .on("enter", function (e) {
            if (!$("#loader").hasClass("active")) {
                $("#loader").addClass("active");
                // if (console) console.log("loading new items");
                // simulate ajax call to add content using the function below
                setTimeout(addBoxes, 1000, 8);
            }
        });

    function addBoxes(amount) {
        var info = $('.scroll-load');
        var action = info.data('action');
        var step = info.data('step');
        // console.log(step);
        $.ajax({
            type: "POST",
            url: '/',
            data: {
                'action': action,
                'step': step
            },
            success: function(data) {
                // $('.scroll-load').masonry('appended', data);
                $('.scroll-load').append(data);
                scrollLoad.masonry('reloadItems');
                scene.update();
                $("#loader").removeClass("active");
                step++;
                info.data('step', step);
            },
            error: function(data) {
                // alert(err_msg);
            }
        });
    }

    // Category group links toggle
    $('.group-title span').click(function() {
        var cgid = $(this).data('cgid');
        $('.cgid-'+cgid).toggleClass('hidden');
    });

    // InfinityLoader AJAX
    var lContainer = $('.load-item-container');
    var lButton = $('.load-items');
    var loading = false;
    lButton.viewportChecker({
        classToAdd: 'loading',
        callbackFunction: function(elem, action) {
            if (action == 'add' && !loading) {
                $(elem).trigger('click');
                loading = true;
            }
        },
        offset: 100,
        repeat: true
    });
    lButton.click(function(event) {
        event.preventDefault();
        var clButton = $(this);
        var tid = clButton.data('tid');
        var load = clButton.data('load');
        var total = clButton.data('total');
        var top = clButton.data('top');
        var days = clButton.data('days');
        var offset = $('.lic-' + tid + ' .block-item').length;
        var clIndicator = $('.load-' + tid);

        if (offset >= total) return;
        clButton.toggleClass('hidden');
        clIndicator.toggleClass('hidden');

        $.ajax({
            type: 'POST',
            url: '/',
            data: {
                action: 'InfinityLoader',
                tid: tid,
                total: total,
                offset: offset,
                load: load,
                top: top,
                days: days
            },
            success: function(data, textStatus, XMLHttpRequest) {
                lContainer.append(data);
                if (data) {
                    loading = false;
                    if ((offset+load) < total) clButton.toggleClass('hidden');
                }
                clIndicator.toggleClass('hidden');
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                // alert(errorThrown);
            }

        })
    });

    // Cookies policy
    var cookie_alert = $('.widget-cookies');
    cookie_alert.find('.btn-accept').click(function(e) {
        e.preventDefault();
        document.cookie="cookie_policy=AcceptCookies; expires=Fri, 31 Dec 2060 12:00:00 UTC; path=/";
        cookie_alert.hide();
    });
    cookie_alert.find('.btn-close').click(function() {
        cookie_alert.hide();
    });

    // Subscribe
    $('.ml-form-close').click(function() {
        var date = new Date();
        date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
        document.cookie="subscribe=CloseSubscribe; expires=" + date.toUTCString() + "; path=/";
        $('.ml-subscribe-form').hide();
    });

});
